import { createFileRoute } from '@tanstack/react-router'
import { WorkflowList } from '@/features/workflows/ui/workflows-list-page'

export const Route = createFileRoute('/_authenticated/tasks/workflows/')({
	component: WorkflowList,
})
